import React, { useContext, useState, useEffect, forwardRef, useImperativeHandle } from 'react'
import { Container, MenuAddMoreWrapper, MenuAddmoreIcon, MenuBestSaller, MenuNonvagefilterWrapper, MenuNonvageFilter, MenuCardWrapper, MenuDeatilsContainer, MenuImage, MenuImageWrapper, MenuName, MenuNameWrapper, MenuPrice, MenuPriceWrapper, MenuStar, MenuStarWrapper, MenuStarvalue, MenuVageFilter, MenuVagefilterWrapper, NewTabMenuHeadingWrapper, NewTabMenuText, NewTabMenuWrapper, SpancurrencySymbol } from './Theme62ExtStyleComponent.js'
import FirstDishImg from "../../../../Images/Restaurant/FirstMenuimg.png";
import StarIcon from "../../../../Images/Restaurant/Star.png";
import AddmoreIcon from "../../../../Images/Restaurant/addmoreicon.png";
import rytIcon from "../../../../Images/Restaurant/restaurantrightclick.jpg";
import BestSellerIcon from "../../../../Images/Restaurant/Bestsellertitle.png";
import { environmentVariables } from "../../../../config/env.config.js";
import axios from 'axios';
import { currencyContext } from "../../../../context/currencyContext.js";

import { userContext } from "../../../../context/userContext.js";
import styled from 'styled-components';
import { getServicesArray } from '../../../../utils/utility.js';
import { useTranslation } from "react-i18next";
import TabAddOn from './TabAddOn.js';
import { use } from 'react';
import { StarRating } from "../../../Components/StarRating/StarRating";

const TabMenu = forwardRef((props,ref) => {
    let colordata = props?.colordata;
    const [addedItems, setAddedItems] = useState(props.addedItems);
    const [menuItems, setMenuItems] = useState([]);
    const [filter, setFilter] = useState('all');
    const [foodMenuData, setFoodMenuData] = useState([]);
    const [vegFilter, setVegFilter] = useState(false);
    const [averageRatings, setAverageRatings] = useState({});
    const { currencyObjData } = useContext(currencyContext);
    const { userData } = useContext(userContext);
    const [currencySymbol, setCurrencySymbol] = useState('₹');
    const { t } = useTranslation();
    const [addOn, setAddOn] = useState(false);
    useImperativeHandle(ref, () => ({
        resetFilter: () => {
          setFilter('all');
          setVegFilter(false); // Also reset veg filter when resetting
        }
      }));
    useEffect(() => {
        if (props.rs?.contactInfo?.content) {
            const contactInfo = JSON.parse(props.rs.contactInfo.content);
            let phoneNumber = contactInfo.contactInfoPhone;
            phoneNumber = phoneNumber.replace(/[^\d+]/g, '');

            let countryCode = phoneNumber.match(/^\+(\d{1,3})/)[1];

            if (countryCode.length < 3) {
                if (phoneNumber.startsWith("+971")) {
                    countryCode = "971";
                } else if (phoneNumber.startsWith("+91")) {
                    countryCode = "91";
                } else if (phoneNumber.startsWith("+1")) {
                    countryCode = "1";
                } else {
                    countryCode = "default";
                }
            }

            switch (countryCode) {
                case '91':
                    setCurrencySymbol('₹');
                    break;
                case '1':
                    setCurrencySymbol('$');
                    break;
                case '971':
                    setCurrencySymbol('AED');
                    break;
                default:
                    setCurrencySymbol('₹'); // Default to INR
                    break;
            }
        }
    }, [props.rs?.contactInfo]);

    const fetchMenuItemsAndReviews = async () => {
        try {
            const menuItemsFromAPI = (props?.rs?.menu?.content);
            setMenuItems(menuItemsFromAPI);

            const response = await axios.get(`${environmentVariables.apiUrl}api/v1/business/fetchreviews?businessId=${props?.rs?.id}`);
            if (Array.isArray(response?.data?.averageRatings)) {
                const ratingsMap = {};

                response?.data?.averageRatings.forEach(item => {
                    ratingsMap[item.name.toLowerCase()] = item?.avgrating;
                });

                setAverageRatings(ratingsMap);
            } else {
                console.log('Average ratings data is not an array:', response?.data?.averageRatings);
            }
        } catch (error) {
            console.log('Error fetching menu items or reviews:', error);
        }
    };

    useEffect(() => {
        fetchMenuItemsAndReviews();
    }, [props?.rs?.id, props?.rs?.menu?.content]);

    useEffect(() => {
        const dataSource = props?.isInternal ? props?.newrestaurantdata : props?.rs?.newrestaurantdata;

        if (dataSource) {
            const formattedData = dataSource.map((item, i) => ({
                name: item?.dish_name || "Unknown Dish",
                price: item?.menu_prices?.dish_price || [],
                quantity: item?.menu_prices?.dish_quantity || [],
                formCount: i.toString(),
                category: item?.dish_category || "unknown",
                image: item?.dish_image || "images",
                vegNonVegCategory: item?.dish_type || "unknown"
            }));

            setFoodMenuData(formattedData);
        }
    }, [props?.isInternal, props?.newrestaurantdata, props?.rs?.newrestaurantdata]);   

    // const handleAddToOrder = (menuItem) => {
    //     console.log(menuItem,'aaaaaaaaaaaa')
    //     const isAdded = isItemAdded(menuItem);
    //     setAddOn(true);
    //     if (isAdded) {
    //         setAddedItems(addedItems.filter(item => item.name !== menuItem.name));
    //         props.handleRemoveFromOrder(menuItem.name);
    //     } else {
    //         const newItem = {
    //             name: menuItem.name,
    //             price: menuItem.price[0],
    //             image: menuItem.image,
    //             quantity: 1
    //         };
    //         setAddedItems([...addedItems, newItem]);
    //         props.handleAddToOrder(menuItem.name, menuItem.price[0], menuItem.image, 1);
    //         setAddOn(false);
    //     }
    // };
    
    const handleAddToOrder = (menuItem) => {
        const isAdded = isItemAdded(menuItem);
        if (isAdded) {
            setAddedItems(addedItems.filter(item => item.name !== menuItem.name));
            props.handleRemoveFromOrder(menuItem.name);
        } else {
            setSelectedMenuItem(menuItem); // Set the selected menu item
            setAddOn(true); // Open the TabAddOn component
        }
    };
    const handleAddOnPay = (menuItem,selectedPrice,selecteditemsize) => {
        // Add the item to the order when "Pay" is clicked in TabAddOn
        const newItem = {
            name: menuItem.name,
            price: selectedPrice || menuItem.price[0],
            image: menuItem.image,
            quantity: 1,
            itemSize:selecteditemsize
        };
        setAddedItems([...addedItems, newItem]);
        props.handleAddToOrder(menuItem.name,selectedPrice || menuItem.price[0], menuItem.image, 1,selecteditemsize);
        setAddOn(false); // Close the TabAddOn component
        setSelectedMenuItem(null); // Clear the selected menu item
    };
    const handlAddOn=()=>{
        setAddOn(true);
        console.log('AddOn');
    }
    const isItemAdded = (menuItem) => {
        return addedItems.some((item) => item.name === menuItem.name);
    };

    // const categories = ["All", "Beverages", "Starters", "Main Course", "Snacks", "Desserts", "Breads", "Sides"];
    const categoryData = props?.dishCategoryData;
    let categories = []
    if(categoryData){
        // categories = ["All", ...categoryData.map((item) => item.name)];
        categories = [{ name: t("All"), category: "all" }, ...categoryData.map((item) => ({ name: item.name, category: String(item.id) }))];
    }else{
        // categories = ["All"]
        categories = [{ name: t("All"), category: "all" }]
    }

    const [selectedMenuItem, setSelectedMenuItem] = useState(null); // Track the selected menu item
    const handleCategoryClick = (name, categoryId) => {
        setFilter(name === 'All' ? 'all' : categoryId);
    };

    const toggleVegFilter = () => {
        setVegFilter((prev) => !prev);
    };

    return (
        <>
      
            <div className='menuCategory'>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: props?.rs?.is_enabledGooglereview ? 'space-between' : "flex-end", padding: '0 10px', marginBottom: '5px' }}>
                    { props?.rs?.is_enabledGooglereview ? 
                    (
                    
                                      <div class="reviewratingcontainer" style={{background:colordata?.dynamicBackgroundColor || ""}}>
                                    <p class="reviewrating"  style={{ color: colordata.dynamicTextDescriptionColor || "", marginTop: "0px" }}>
                                      <StarRating value={props?.rs?.rating} totalStars={1} starSize="16px" themeNo={62} />
                                    <span class="ratingspan"  style={{color: colordata.dynamicTextDescriptionColor || "" }}> {props?.rs.rating }</span>   {t("Google_rating")} 
                                      </p>
                                    </div>
                                      ) : ""}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: '0 10px', gap: '8px', marginBottom: '5px' }}>
                        <span style={{ color: `${colordata?.dynamicTextHeadingColor || 'white'}`, fontSize: '16px' }}>{t("Pure_veg")}</span>
                        <div onClick={toggleVegFilter} style={{
                            width: '50px',
                            height: '24px',
                            borderRadius: '20px',
                            // background: vegFilter ? '#1E3833' : '#381E1E',
                            background: vegFilter ? '#1E3833' : '#1E3833',
                            display: 'flex',
                            alignItems: 'center',
                            padding: '2px 0',
                            cursor: 'pointer',
                            border: vegFilter ? "1px solid #0BB70B":"1px solid ",
                        }}>
                            <div style={{
                                width: '18px',
                                height: '18px',
                                borderRadius: '50%',
                                // background: vegFilter ? '#008200' : '#E72727',
                                background: vegFilter ? '#0BB70B' : '#0082005c',
                                transform: vegFilter ? 'translateX(28px)' : 'translateX(2px)',
                                transition: 'transform 0.2s ease'
                            }}></div>
                        </div>
                    </div>
                </div>
                {/* borderBottom: colordata.dynamicMainBackgroundColor ? `1px solid ${colordata.dynamicMainBackgroundColor}90` : '1px solid #303030'*/}
                <div className='categoryList' style={{ borderBottom: colordata.dynamicBackgroundColor ? `0.5px solid ${colordata.dynamicBackgroundColor}` : '0.5px solid #303030' }}> 
                    <ul style={{ display: 'flex', overflow: 'scroll', margin: '0px 5px' }}>
                        {categories.map((item, index) => {
                            return (
                                <li key={item.category}
                                    onClick={() => handleCategoryClick(item.name, item.category)}
                                    style={{
                                        padding: '5px 20px 15px 20px',
                                        cursor: 'pointer',
                                        // fontSize: '18px',
                                        fontSize: '14px',
                                        color: filter === item.category
                                            ? (`${colordata?.dynamicTextHeadingColor || '#FF7622'}`)
                                            : (colordata.dynamicTextHeadingColor ? `${colordata.dynamicTextHeadingColor}90` : '#FFFFFF'),
                                        borderBottom: filter === item.category
                                            ? (colordata.dynamicTextHeadingColor ? `3px solid ${colordata.dynamicTextHeadingColor}` : "3px solid #FF7622")
                                            : 'none'
                                    }}
                                >
                                    {item.name}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        <NewTabMenuWrapper>
            <Container>
                <MenuDeatilsContainer>
                    {getServicesArray(foodMenuData).filter((menuItem) => {
                        // Filter by category
                        const categoryMatch = filter === 'all' || menuItem.category.toLowerCase() === filter;

                        // Filter by veg/non-veg if toggle is on
                        const vegMatch = !vegFilter || menuItem.vegNonVegCategory === 'veg';

                        return categoryMatch && vegMatch;
                    }).map((menuItem, index) => (
                        <MenuCardWrapper key={index} style={{ background: colordata?.dynamicBackgroundColor || "" }}>
                            <MenuImageWrapper>
                                <MenuImage
                                    src={
                                        menuItem?.image === ""
                                            ? `${environmentVariables.apiUrl}uploads/No image available.png`
                                            : menuItem?.image.includes('/')
                                                ? `https://businessbay.b-cdn.net${menuItem?.image}`
                                                : `${environmentVariables.s3UrlBackendUrl}${menuItem?.image}`
                                    }
                                    // src={menuItem?.image}
                                />
                                {menuItem.vegNonVegCategory !== "veg" ? (
                                    <MenuNonvagefilterWrapper>
                                        <MenuNonvageFilter />
                                    </MenuNonvagefilterWrapper>
                                ) : (
                                    <MenuVagefilterWrapper>
                                        <MenuVageFilter />
                                    </MenuVagefilterWrapper>
                                )}
                            </MenuImageWrapper>
                            <MenuNameWrapper>
                                <MenuName>
                                    <div className='menu2line' style={{ color: colordata?.dynamicTextDescriptionColor || "" }}>
                                        {menuItem?.name ? (menuItem.name.length >= 45 ? `${menuItem.name.slice(0, 42)}...` : menuItem.name) : ""}
                                    </div>
                                </MenuName>
                            </MenuNameWrapper>
                            <MenuPriceWrapper>
                                <MenuPrice style={{ color: colordata?.dynamicTextDescriptionColor || "" }}>
                                    <SpancurrencySymbol>{currencySymbol}</SpancurrencySymbol>{Number(menuItem?.price[0] || 0).toFixed(2)}
                                </MenuPrice>
                                <MenuAddMoreWrapper>
                                    {isItemAdded(menuItem) ? (
                                        <span className='addedToCart'
                                            style={{
                                                color: colordata?.dynamicCtaTextColor || "#fff",
                                                background: colordata?.dynamicCtaColor || "#FF7622",
                                            }}
                                            onClick={() => handleAddToOrder(menuItem)}
                                        >
                                            + {t("Added")}
                                        </span>
                                    ) : (
                                        <span className='addToCart'
                                            style={{
                                                color: colordata?.dynamicCtaTextColor || "",
                                                border: colordata.dynamicCtaTextColor ? `1px solid ${colordata.dynamicCtaTextColor}` : "",
                                            }}
                                            onClick={() => handleAddToOrder(menuItem)}
                                            // onClick={() => handlAddOn()}
                                            
                                        >
                                            + {t("Add")}
                                        </span>
                                    )}
                                </MenuAddMoreWrapper>
                            </MenuPriceWrapper>
                        </MenuCardWrapper>
                    ))}
                </MenuDeatilsContainer>
            </Container>
        {/* {addOn &&  */}
        {addOn && selectedMenuItem && 
        <TabAddOn handleAddToOrder={handleAddToOrder} 
        menuItem={selectedMenuItem}
        colordata={colordata}
        handleAddOnPay={handleAddOnPay} setAddOn={setAddOn}></TabAddOn>}
        </NewTabMenuWrapper>

        </>
    );
});
export default TabMenu;